import React, { useState } from 'react'
import { useFormik } from 'formik'
import { object, string } from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'

import Input from 'components/forms/input'
import Password from 'components/forms/password'
import SignUpModal from 'components/modals/signUp'
import useApi from 'utils/fetch'
import Form from 'components/forms/form'
import { UPGRADE, UPGRADE_MESSAGE, AUTO_SIGN_OUT_SECONDS } from '.config'
import Typography from 'components/typography/paragraph'
import SignUpComponent from 'components/buttons/signUpComponent'
import { setEmail } from 'store/actions/email'
import { afterSignIn } from 'store/batches'
import { signInFlow } from 'utils/iot'
import { setSignUp } from 'store/actions/signUp'
const InvestorTypeModal = dynamic(() => import('components/modals/investorType'), { ssr: false })

export default function SignIn ({ userType }) {
  const dispatch = useDispatch()
  const [openSignUp, setOpenSignUp] = useState(false)
  const [open, setInvestorTypeOpen] = useState(false)
  const [signUpType, setSignUpType] = useState('default')
  const email = useSelector((state) => state.email.value)
  const { API } = useApi()

  const onOpenSignUp = () => {
    dispatch(setSignUp(null))
    setOpenSignUp(true)
  }

  const onSubmit = async (data) => {
    const [response] = await Promise.all([
      API({ type: 'pass', ...data })('signIn'),
      signInFlow(data?.email, API, dispatch)
    ])

    if (response?.response) {
      const { response: response2 } = response
      response2.expiry = Date.now() + AUTO_SIGN_OUT_SECONDS
      dispatch(afterSignIn(response2))
      const compliance = response2?.roles?.includes('compliance-uk')
      const bank = response2?.roles?.includes('bank')
      window.open(`https://${window.location.hostname}/${compliance ? 'admin/deals' : bank ? 'admin/spv' : 'profile'}`, '_self')
    }
  }

  const validationSchema = object().shape({
    email: string().email('Please enter correct email').required('Email is required'),
    password: string().min(12, 'Minimum password length is 12 characters').max(32, 'Maximum of the password is 32 characters').required('Password is required')
  })

  const formik = useFormik({
    initialValues: {
      email: email || '',
      password: ''
    },
    validationSchema,
    onSubmit
  })

  const handleChange = (e) => {
    dispatch(setEmail(e.target.value))
    formik.handleChange('email')(e)
  }

  if (UPGRADE) return <Typography>{ UPGRADE_MESSAGE }</Typography>

  return (
      <>
        <Form onSubmit={formik.handleSubmit}>
          <Input
            label="Email"
            name="email"
            placeholder="me@mydomain.com"
            type="text"
            autoComplete="email"
            onChange={handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            errors={formik.errors.email}
            touched={formik.touched.email}
            disabled={formik.isSubmitting} />
          <Password
            label="Password"
            name="password"
            autoComplete="current-password"
            placeholder="**********"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
            errors={formik.errors.password}
            touched={formik.touched.password}
            disabled={formik.isSubmitting}
            showForgot />

          <SignUpComponent
            label="Login"
            type={2}
            onOpenSignUp={onOpenSignUp}
            setSignUpType={setSignUpType}
            setInvestorTypeOpen={setInvestorTypeOpen}
            formik={formik} />
        </Form>

        <SignUpModal open={openSignUp} setOpen={setOpenSignUp} />
        <InvestorTypeModal
          userType={userType}
          setInvestorTypeOpen={setInvestorTypeOpen}
          open={open}
          type={signUpType} />
      </>
  )
}

SignIn.propTypes = {
  userType: PropTypes.string
}
